(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-action-link"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[data-cut-link]');
      if (!link || !link.getAttribute('href') || link.classList.contains('is-cutting')) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || link.target === '_blank') return;
      e.preventDefault();
      var href = link.href;
      link.classList.add('is-cutting');
      setTimeout(function () { window.location.href = href; }, 320);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["empty-state"] && !Shopify.designMode) return;
  try {
    (function () {
    // Play the underline "cut" then navigate — works for every .empty-state__link site-wide.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-empty-link]');
      if (!link || !link.getAttribute('href') || link.classList.contains('is-cutting')) return;
      e.preventDefault();
      var href = link.href;
      link.classList.add('is-cutting');
      setTimeout(function () { window.location.href = href; }, 320);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
